/**
 * Returns an object from a query params strings
 * @param {string} queryParamsString - query params to be converted into an object.
 * Example: "?error=server_error&error_description=unexpected_error_occurred"
 * To: {error: 'server_error', error_description: 'unexpected_error_occurred' }
 */
var queryParamsToObject = function (queryParamsString) {
    var searchParams = queryParamsString;
    if (queryParamsString.includes('?')) {
        searchParams = searchParams.substring(1);
    }
    var params = new URLSearchParams(searchParams);
    var errorObjectParams = {};
    params.forEach(function (value, key) {
        errorObjectParams[key] = value;
    });
    return errorObjectParams;
};
export default queryParamsToObject;
